import { FC } from "react";
import { AdminAssessments } from "../../../modules/admin/components/screens/admin-assessments/admin-assessments";

export const AdminAssessmentsRoute: FC = () => {
    return (
        <AdminAssessments />
    )
}